import React from "react";
import { Grid, Typography, Box, TextField, Checkbox, Radio, Button, RadioGroup,  } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import DocCard from "../../Components/DocCard";
import { ReactComponent as StarSVG } from "../../Images/star.svg";
import { ReactComponent as CheckboxBorder } from "../../Images/checkboxBorder.svg";

const useStyle = makeStyles((theme: Theme) => ({
    contentWWrapper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            padding: 70
        },
    },
    leftContentWrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "50%",
        height: "80%"
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    serviceTypeContainer: {
    },
    boxContent: {
        height: "50%"
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
        width: "260px",
        height: "425px",
        alignItems: "center",
        justifyContent: "space-between"
    },
    docPhoto: {
        display: "flex",
        justifyContent: "center"
    },
    devideBorrder: {
        border: "1px solid #CCCDE5",
        width: "100%"
    }
}));
const VetProfile = () => {
    const classes = useStyle();
    return (
        <Grid container spacing={1}>
            <Box className={classes.contentWWrapper}>
                {/*<DocCard />*/}
                <Box className={classes.leftContentWrapper}>
                    <Box>
                        <Typography variant="h2">Rate your experience!</Typography>
                    </Box>
                    <Box marginTop="48px">
                        <Typography variant="h4">How was your appointment with Dr. Steven Radbill today?</Typography>
                    </Box>
                    <Box marginTop="25px">
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                        <StarSVG />
                    </Box>
                    <Box marginTop="24px">
                        <Typography variant="h4">What’s the main driver for this rating?</Typography>
                        <Box marginTop="24px">
                            <Grid container justify="space-between">
                                <Button type="button" variant="outlined">Friendliness</Button>
                                <Button type="button" variant="outlined">Respectfulness</Button>
                                <Button type="button" variant="outlined">Platform</Button>
                                <Button type="button" variant="outlined">Logistics</Button>
                            </Grid>
                        </Box>
                    </Box>
                    <Box marginTop="48px">
                        <Typography variant="h4">Add a comment</Typography>
                        <TextField
                            multiline
                            placeholder="Describe the details"
                            variant="outlined"
                            fullWidth
                            style={{height: 110, marginTop: 24}}
                        />
                    </Box>
                    <Grid container>
                        <Typography variant="h4">Diagnoses</Typography>
                        <Grid item container direction="row">
                            <Grid item container alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container  alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container  alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container  alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container  alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                            <Grid item container  alignItems="center" sm={6}>
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder />}
                                />
                                <Typography>Otitis Externa</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box marginTop="48px" marginBottom="50px">
                        <Typography variant="h4">Did the appointment result in a prescription?</Typography>
                        <Box marginTop="24px">
                            <RadioGroup>
                                <Grid item container direction="row">
                                    <Grid item container alignItems="center" sm={6}>
                                        <Radio
                                            color="secondary"
                                            checked
                                        />
                                        <Typography>Yes</Typography>
                                    </Grid>
                                    <Grid item container  alignItems="center" sm={6}>
                                        <Radio
                                            color="secondary"
                                            checked={false}
                                        />
                                        <Typography>No</Typography>
                                    </Grid>
                                </Grid>
                            </RadioGroup>
                        </Box>
                    </Box>
                    <Button
                        type="button"
                        variant="outlined"
                    >
						Submit Review
                    </Button>
                    <Box marginTop="24px" marginBottom="50px">
                        <Grid container direction="row" alignItems="center">
                            <Checkbox
                                color="secondary"
                                icon={<CheckboxBorder />}
                            />
                            <Typography>MVV may use my review for marketing purposes</Typography>
                        </Grid>
                    </Box>
                </Box>   
            </Box>
        </Grid>
    );
};

export default VetProfile;
